import { deleteCardToken } from "../../services/api";

export const sdkDeleteCard = async ({
  cardId,
  intentSecret,
  lang,
}: {
  cardId: string;
  intentSecret: string;
  lang: string;
}) => {
  await deleteCardToken(cardId, intentSecret, lang);
  return { message: "success" };
};
